//门禁管理
export default [
  {
    path: '/smartLock',
    component: () => import('../pages/smartLockManage/smartLock.vue'),
    name: 'smartLock',
    title: "门禁设备管理",
    meta: {
      title: "门禁设备管理"
    }
  },
  {
    path: '/smartLockBill',
    component: () => import('../pages/smartLockManage/smartLockBill.vue'),
    name: 'smartLockBill',
    title: "门禁开锁记录",
    meta: {
      title: "门禁开锁记录"
    }
  }
];
